import React from 'react';

import { HeaderTab, HeaderTabBar } from './header-tab-bar';

import { forTemplate } from 'common/lib/util/i18n';
const l = forTemplate('home');

interface TeamCardsProps extends React.HTMLAttributes<HTMLDivElement> {
  orgname: string;
  cardsTabName: string;
  onClickDueTab: () => void;
  onClickAssignedTab: () => void;
}

export const TeamCards: React.StatelessComponent<TeamCardsProps> = ({
  cardsTabName,
  children,
  orgname,
  onClickDueTab,
  onClickAssignedTab,
  ...props
}) => (
  <div {...props}>
    <HeaderTabBar>
      <HeaderTab
        isSelected={cardsTabName === 'due'}
        iconName="calendar"
        url={cardsTabName !== 'due' ? `/${orgname}/cards/due` : undefined}
        onClick={cardsTabName !== 'due' ? onClickDueTab : undefined}
      >
        {l('due-dates')}
      </HeaderTab>
      <HeaderTab
        isSelected={cardsTabName === 'assigned'}
        iconName="card"
        url={
          cardsTabName !== 'assigned' ? `/${orgname}/cards/assigned` : undefined
        }
        onClick={cardsTabName !== 'assigned' ? onClickAssignedTab : undefined}
      >
        {l('assigned')}
      </HeaderTab>
    </HeaderTabBar>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards.tsx